import type { Messages } from "./en";

// Hindi (Devanagari).
export const hi: Messages = {
  "nav.home": "LEARNABLE होम",
  "nav.main": "मुख्य",
  "nav.courses": "कोर्स",
  "nav.review": "दोहराव",
  "nav.progress": "प्रगति",
  "nav.guide": "गाइड",
  "nav.marketplace": "मार्केटप्लेस",
  "nav.streak": "लगातार पढ़ाई के दिन: {n}",
  "nav.xp": "कुल अनुभव: {n} XP",

  "account.menu": "खाता",
  "account.settings": "सेटिंग्स",
  "account.guide": "LEARNABLE कैसे काम करता है",
  "account.signOut": "साइन आउट",

  "common.save": "सहेजें",
  "common.saved": "सहेज लिया गया।",
  "common.saving": "सहेजा जा रहा है…",
  "common.cancel": "रद्द करें",
  "common.close": "बंद करें",
  "common.pleaseWait": "कृपया प्रतीक्षा करें…",

  "signin.title": "LEARNABLE में साइन इन करें",
  "signin.registerTitle": "अपना खाता बनाएँ",
  "signin.email": "ईमेल",
  "signin.password": "पासवर्ड",
  "signin.passwordRule": "कम से कम 12 अक्षर।",
  "signin.submit": "साइन इन करें",
  "signin.register": "खाता बनाएँ",
  "signin.forgot": "पासवर्ड भूल गए?",
  "signin.toRegister": "नया खाता बनाएँ",
  "signin.toSignIn": "मेरा खाता पहले से है",
  "signin.language": "भाषा",

  "password.current": "मौजूदा पासवर्ड",
  "password.new": "नया पासवर्ड (कम से कम 12 अक्षर)",
  "password.change": "पासवर्ड बदलें",
  "password.changed": "पासवर्ड बदल दिया गया। आपके दूसरे डिवाइस साइन आउट हो गए हैं।",

  "settings.title": "सेटिंग्स",
  "settings.intro": "आपकी प्रोफ़ाइल और पसंद। ये आपके खाते में सहेजी जाती हैं और आपके सभी डिवाइस पर लागू होती हैं।",
  "settings.profile": "प्रोफ़ाइल",
  "settings.displayName": "दिखने वाला नाम",
  "signin.emailOrUsername": "ईमेल या उपयोगकर्ता नाम",
  "signin.username": "उपयोगकर्ता नाम (वैकल्पिक)",
  "signin.usernameHint": "3–30 अक्षर, अंक, बिंदु, अंडरस्कोर या हाइफ़न। ईमेल की जगह इससे साइन इन कर सकते हैं।",
  "settings.username": "उपयोगकर्ता नाम",
  "settings.usernameHint": "वैकल्पिक। ईमेल की जगह इस नाम से साइन इन करने देता है। दूसरे इसे नहीं देखते। हटाने के लिए खाली छोड़ें।",
  "settings.displayNameHint": "आपके ईमेल की जगह दिखाया जाता है। ईमेल इस्तेमाल करने के लिए इसे खाली छोड़ें।",
  "settings.email": "ईमेल",
  "settings.emailHint": "वह पता जिससे आप साइन इन करते हैं।",
  "settings.language": "भाषा",
  "settings.languageHint": "मेनू और पेजों की भाषा। आपके कोर्स की सामग्री और AI की प्रतिक्रिया कोर्स की अपनी भाषा में ही रहती है।",
  "settings.translationNote": "अनुवाद जारी है: कुछ स्क्रीन अभी भी अंग्रेज़ी में हैं।",
  "settings.study": "पढ़ाई",
  "settings.timezone": "समय क्षेत्र",
  "settings.timezoneHint": "आपका पढ़ाई का दिन, लगातार दिन और रोज़ का लक्ष्य इसी समय क्षेत्र के अनुसार चलते हैं।",
  "settings.dailyGoal": "रोज़ का लक्ष्य",
  "settings.dailyGoalHint": "प्रतिदिन उत्तरों की संख्या।",
  "settings.security": "सुरक्षा",
  "settings.signOutHint": "साइन आउट करने पर आपके खाते का डेटा इस ब्राउज़र से हटा दिया जाता है।",

  "guide.title": "LEARNABLE कैसे काम करता है",
  "guide.intro": "LEARNABLE आपकी अपनी पढ़ाई की सामग्री से सवाल बनाता है, आपके उत्तर जाँचता है और हर दोहराव ठीक उस समय रखता है जब आप भूलने वाले होते हैं।",
  "guide.contents": "विषय-सूची",
  "guide.structure.title": "1. कोर्स कैसे बना होता है",
  "guide.structure.body": "एक कोर्स अध्यायों में बँटा होता है, अध्याय विषयों में और विषय अवधारणाओं में। हर अवधारणा में सीखने की इकाइयाँ होती हैं: याद रखने वाली बातें, जिनमें से हर एक को एक या अधिक सवालों से पूछा जाता है।",
  "guide.material.title": "2. अपनी सामग्री जोड़ें",
  "guide.material.body": "कोई कोर्स खोलें और PDF, Word, PowerPoint, टेक्स्ट या Markdown फ़ाइलें अपलोड करें, या टेक्स्ट चिपकाएँ। अगर आपके पास पहले से सवाल-जवाब हैं, तो उन्हें \"Question:\" और \"Answer:\" (या \"Domanda:\" और \"Risposta:\") से शुरू होने वाली पंक्तियों में अपलोड करें: हर एक बिना AI के एक अवधारणा बन जाता है।",
  "guide.curriculum.title": "3. पाठ्यक्रम बनाएँ",
  "guide.curriculum.body": "AI से अपनी सामग्री के आधार पर अध्याय, विषय और अवधारणाएँ सुझाने को कहें। सुझाव देखें, जो चाहें उसका नाम बदलें, उसे हिलाएँ या हटाएँ, फिर उसे स्वीकार करें। स्वीकार करने तक कुछ नहीं बदलता।",
  "guide.study.title": "4. किसी अवधारणा को पढ़ें",
  "guide.study.body": "कोई अवधारणा खोलें और सक्रिय करें दबाएँ: आपकी सामग्री से सीखने की इकाइयाँ तैयार होती हैं। उन्हें पढ़ें, फिर \"मैंने यह अवधारणा पढ़ ली\" दबाएँ। हर प्रश्न तब तक पूछा जाता है जब तक आप उसे तीन बार अच्छी तरह न दे दें (लगातार होना ज़रूरी नहीं), हर उत्तर के बाद प्रतिक्रिया के साथ।",
  "guide.answer.title": "5. उत्तर दें और प्रतिक्रिया पाएँ",
  "guide.answer.body": "अपना उत्तर अपने शब्दों में लिखें, या बोलकर लिखवाने के लिए \"अपना जवाब बोलें\" दबाएँ। संकेत उपलब्ध है, लेकिन उससे XP आधे हो जाते हैं। AI शब्दों को नहीं, अर्थ को जाँचता है, और चार अंक तथा सही, छूटी हुई और गलत बातों की सूची दिखाता है। संदर्भ उत्तर और उसके स्रोत हमेशा एक क्लिक पर उपलब्ध हैं।",
  "guide.disagree.title": "6. अगर आप सहमत नहीं हैं",
  "guide.disagree.body": "\"Disagree with the grade?\" दबाएँ। आप कारण बताकर AI से दूसरी राय माँग सकते हैं (दोनों दिखती रहती हैं), या खुद उत्तर को ग्रेड दे सकते हैं। आपका अपना ग्रेड हमेशा मान्य होता है।",
  "guide.review.title": "7. समय पर दोहराएँ",
  "guide.review.body": "हर उत्तर उसके सवाल को एक समय-सारिणी में रखता है: जितना बेहतर आप उसे जानते हैं, वह उतनी देर से लौटता है। दोहराव पेज और आपका डैशबोर्ड दिखाते हैं कि क्या बाकी है और उसमें लगभग कितना समय लगेगा।",
  "guide.progress.title": "8. अपनी प्रगति देखें",
  "guide.progress.body": "लगातार दिन गिनते हैं कि आपने कितने दिन पढ़ाई की, XP सही उत्तरों का इनाम है और रोज़ का लक्ष्य आपकी गति तय करता है। \"जो आप बार-बार गलत करते हैं\" आपके हाल के उत्तरों में मिली गलतियाँ इकट्ठा करता है, अभ्यास के बटन के साथ।",
  "guide.organise.title": "9. सब कुछ व्यवस्थित रखें",
  "guide.organise.body": "\"सवाल प्रबंधित करें\" में आप अलग-अलग सवाल या पूरे अध्याय, विषय और अवधारणाएँ चुनकर उन्हें हटा, रोक, फिर शुरू या दूसरी जगह ले जा सकते हैं, किसी सवाल को बदल सकते हैं, और क्रम बदलने के लिए ⠿ खींच सकते हैं। लंबे हिस्से उनके शीर्षक के पास वाले तीर से बंद होते हैं।",
  "guide.marketplace.title": "10. कोर्स साझा करें और पाएँ",
  "guide.marketplace.body": "मार्केटप्लेस में आप दूसरे उपयोगकर्ताओं के बनाए कोर्स श्रेणी, स्तर, भाषा और आकार के अनुसार ढूँढ सकते हैं। जोड़ने से पहले आप उसका पेज देखते हैं: उसमें क्या है, किसके लिए है, आप क्या सीखेंगे, उसके अध्याय और कितने सवाल हैं। \"मेरे कोर्स में जोड़ें\" उसे आपके डैशबोर्ड पर रख देता है: लेखक सवालों को अपडेट रखता है और आप उन्हें बदल नहीं सकते, लेकिन आपकी पढ़ाई आपकी अपनी है (आपकी योजना, जवाब, XP और हर सवाल को दी गई आपकी प्राथमिकता)। लेखक की सामग्री डाउनलोड नहीं की जा सकती। अपना कोर्स साझा करने के लिए उसे खोलें, उसका \"मार्केटप्लेस पेज\" लिखें, ड्राफ़्ट के रूप में सहेजें और फिर प्रकाशित करें।",
  "guide.glossary.title": "ऐप में इस्तेमाल होने वाले शब्द",
  "guide.term.concept": "अवधारणा",
  "guide.term.concept.def": "आपके कोर्स का एक विचार, जैसे कोई परिभाषा या नियम।",
  "guide.term.item": "सीखने की इकाई",
  "guide.term.item.def": "किसी अवधारणा के अंदर याद रखने वाली एक बात, उसके सवालों और अपेक्षित उत्तर के साथ।",
  "guide.term.active": "Active (सक्रिय)",
  "guide.term.active.def": "अवधारणा पढ़ाई और दोहराव में शामिल होती है। रोकी गई या न पढ़ी गई अवधारणाएँ नहीं।",
  "guide.term.grades": "फिर से · कठिन · अच्छा · आसान",
  "guide.term.grades.def": "फिर से, कठिन, अच्छा, आसान: आप उत्तर कितना अच्छी तरह जानते थे। इसी से तय होता है कि सवाल कब लौटेगा।",
  "guide.term.mastery": "महारत",
  "guide.term.mastery.def": "आपके दोहरावों के आधार पर अनुमान कि आपको कोई अवधारणा कितनी अच्छी तरह याद है।",
  "guide.term.xp": "XP और लगातार दिन",
  "guide.term.xp.def": "सही उत्तरों के अंक, और लगातार कितने दिन आपने पढ़ाई की।",
  "guide.privacy.title": "आपका डेटा",
  "guide.privacy.body": "आपके कोर्स, उत्तर और प्रगति सिर्फ़ आपको दिखते हैं। बोलकर लिखवाया गया उत्तर आपका ब्राउज़र टेक्स्ट में बदलता है; सिर्फ़ टेक्स्ट रखा जाता है।",
  "help.button": "मदद: {topic}",
  "help.more": "और जानें",
  "help.nextStep": "अभी करने लायक सबसे उपयोगी काम। बाकी दोहराव हमेशा पहले आते हैं, फिर नई सामग्री।",
  "help.courses": "हर कोर्स का एक कार्ड। हरा बटन बाकी दोहराव करवाता है; नीला बटन कुछ नया आगे बढ़ाता है।",
  "help.streak": "लगातार कितने दिन आपने कम से कम एक उत्तर दिया। इसे जारी रखने के लिए आज एक सवाल का उत्तर दें।",
  "help.xp": "सही उत्तरों पर मिलने वाले अनुभव अंक। संकेत लेने से ये आधे हो जाते हैं।",
  "help.goal": "आप हर दिन कितने उत्तर देना चाहते हैं। इसे सेटिंग्स में बदल सकते हैं।",
  "help.planner": "हर समय तक कितने सवाल बाकी हो जाएँगे और उनमें लगभग कितना समय लगेगा।",
  "help.coursePlanner": "केवल इस कोर्स के लिए: इसके कितने प्रश्न कब देय होंगे और लगभग कितना समय लगेगा। नई सामग्री में हर प्रश्न के लिए कम से कम तीन अच्छे उत्तर चाहिए।",
  "help.activity": "हर दिन का एक खाना: जितना गहरा, उतने ज़्यादा उत्तर।",
  "help.concept": "अवधारणा आपके कोर्स का एक विचार है। उसके सवाल तैयार करने के लिए उसे पढ़ना शुरू करें, उसकी सीखने की इकाइयाँ पढ़ें, फिर अभ्यास करें।",
  "help.consolidate": "नीचे की सीखने की इकाइयाँ पढ़ लेने पर बटन दबाएँ। हर प्रश्न तब तक पूछा जाता है जब तक आप उसे तीन बार अच्छी तरह न दे दें, ताकि वह याद रहे।",
  "help.study": "उत्तर अपने शब्दों में लिखें या बोलकर लिखवाएँ। AI शब्दों को नहीं, अर्थ को जाँचता है और बताता है कि क्या सही था या छूट गया।",
  "help.questions": "अलग-अलग सवाल या पूरा अध्याय, विषय या अवधारणा चुनें, फिर उन्हें हटाएँ, रोकें या दूसरी जगह ले जाएँ। क्रम बदलने के लिए ⠿ खींचें।",
  "help.marketplace": "दूसरे उपयोगकर्ताओं के बनाए कोर्स। किसी को खोलकर देखें कि उसमें क्या है और कितने सवाल हैं; अपनी योजना से पढ़ने के लिए उसे जोड़ें। लेखक उसे अपडेट रखता है।",
  "help.weakSpots": "आपके हाल के उत्तरों में मिली गलतियाँ, अवधारणा के अनुसार। तब तक अभ्यास करें जब तक वे इस सूची से गायब न हो जाएँ।",
  "help.material": "PDF, Word, PowerPoint या टेक्स्ट फ़ाइलें अपलोड करें, या टेक्स्ट चिपकाएँ। LEARNABLE इनसे कोर्स और उसके सवाल बनाता है।",
  "start.title": "LEARNABLE कैसे काम करता है",
  "start.intro": "चार कदम। गाइड में देखने के लिए किसी को भी खोलें।",
  "start.hide": "समझ गया, छिपाएँ",
  "start.reopen": "दिखाएँ कि LEARNABLE कैसे काम करता है",
  "start.material.title": "अपनी सामग्री जोड़ें",
  "start.material.body": "एक कोर्स बनाएँ और अपने नोट्स, स्लाइड या किताबें अपलोड करें, या टेक्स्ट चिपकाएँ।",
  "start.plan.title": "योजना स्वीकार करें",
  "start.plan.body": "AI अध्याय और अवधारणाएँ सुझाता है। जो चाहें बदलें, फिर स्वीकार करें।",
  "start.study.title": "पढ़ें और उत्तर दें",
  "start.study.body": "एक अवधारणा पढ़ें, फिर उसके सवालों के उत्तर अपने शब्दों में या बोलकर दें।",
  "start.review.title": "समय पर दोहराएँ",
  "start.review.body": "सवाल ठीक उस समय लौटते हैं जब आप उन्हें भूलने वाले होते हैं। हरे बटन का पालन करें।",
  "nav.community": "समुदाय",
  "community.title": "समुदाय",
  "community.intro": "देखें कि सबसे ज़्यादा अनुभव कौन कमा रहा है, दूसरे सीखने वालों को फ़ॉलो करें और उनका हौसला बढ़ाएँ।",
  "community.tab.leaderboard": "लीडरबोर्ड",
  "community.tab.friends": "दोस्त",
  "community.period": "अवधि",
  "community.scope": "कौन",
  "community.period.day": "आज",
  "community.period.week": "इस सप्ताह",
  "community.period.month": "इस महीने",
  "community.period.all": "अब तक",
  "community.scope.everyone": "सभी",
  "community.scope.friends": "दोस्त",
  "community.leader": "सबसे आगे",
  "community.xp": "{n} XP",
  "community.you": "आप",
  "community.yourPlace": "आपकी जगह",
  "community.empty": "इस अवधि में अभी तक किसी ने XP नहीं कमाया।",
  "community.emptyFriends": "यहाँ तुलना करने के लिए दूसरे सीखने वालों को फ़ॉलो करें।",
  "community.windowNote": "दिन UTC समय से गिने जाते हैं; सप्ताह सोमवार से शुरू होता है। केवल वही लोग दिखते हैं जो समुदाय से जुड़े हैं।",
  "community.joinTitle": "समुदाय से जुड़ें",
  "community.joinText": "आप अभी लीडरबोर्ड पर नहीं हैं। उस पर दिखने, खोजे जाने और फ़ॉलो किए जाने के लिए समुदाय में दृश्यता चालू करें। दूसरों को केवल आपका प्रदर्शित नाम और आपके XP दिखते हैं, ईमेल कभी नहीं।",
  "community.joinButton": "मुझे समुदाय में दिखाएँ",
  "community.needName": "पहले सेटिंग्स में एक प्रदर्शित नाम चुनें।",
  "community.follow": "फ़ॉलो करें",
  "community.following": "फ़ॉलो कर रहे हैं",
  "community.friend": "दोस्त",
  "community.followsYou": "आपको फ़ॉलो करता है",
  "community.since": "{date} से यहाँ सीख रहे हैं",
  "community.statXpTotal": "कुल XP",
  "community.statXpWeek": "इस सप्ताह के XP",
  "community.statStreak": "लगातार दिन",
  "community.statFollowers": "फ़ॉलोअर्स",
  "community.statFollowing": "फ़ॉलो कर रहे हैं",
  "community.followingList": "जिन्हें आप फ़ॉलो करते हैं",
  "community.followersList": "आपके फ़ॉलोअर्स",
  "community.searchLabel": "नाम से सीखने वालों को खोजें",
  "community.searchPlaceholder": "प्रदर्शित नाम से खोजें",
  "community.search": "खोजें",
  "community.noResults": "कोई नहीं मिला। केवल समुदाय से जुड़े लोग ही खोजे जा सकते हैं।",
  "community.noFollowing": "आप अभी किसी को फ़ॉलो नहीं कर रहे हैं।",
  "community.noFollowers": "अभी कोई फ़ॉलोअर नहीं है।",
  "community.streakDays": "{n} दिन लगातार",
  "community.xpToday": "आज {n} XP",
  "community.notFound": "यह प्रोफ़ाइल उपलब्ध नहीं है।",
  "community.seeLeaderboard": "समुदाय का लीडरबोर्ड देखें",
  "course.leaderboardLink": "कोर्स लीडरबोर्ड",
  "course.leaderboardTitle": "कोर्स लीडरबोर्ड",
  "course.leaderboardIntro": "इस कोर्स वाले सभी लोगों द्वारा इसमें कमाए गए XP।",
  "course.leaderboardPrivate": "यह एक निजी कोर्स है, इसलिए इसके लीडरबोर्ड पर केवल आप हैं। मार्केटप्लेस के कोर्स उन सभी के साथ साझा होते हैं जिनके पास वे हैं।",
  "course.leaderboardParticipants": "{n} सीखने वाले इस कोर्स को साझा करते हैं।",
  "settings.community": "समुदाय",
  "settings.communityToggle": "मुझे समुदाय में दिखाएँ (लीडरबोर्ड, खोज और फ़ॉलो)",
  "settings.communityHint": "डिफ़ॉल्ट रूप से बंद। दूसरों को केवल आपका प्रदर्शित नाम, आपके XP और आपकी लगातार दिनों की गिनती दिखती है; आपका ईमेल, कोर्स या जवाब कभी नहीं। इसे चालू करने के लिए प्रदर्शित नाम ज़रूरी है।",
  "study.repeat.badge": "लगभग सही: इसे दोहराएँ",
  "study.repeat.title": "संदर्भ उत्तर देखें, फिर उसे दोहराएँ",
  "study.repeat.body": "आपका उत्तर ज़्यादातर बिंदुओं पर मज़बूत था। ऊपर का संदर्भ उत्तर पढ़ें, फिर उसे अपने शब्दों में दोबारा लिखें। अच्छी तरह दोहराया तो यह सही उत्तर गिना जाएगा और आपकी योजना आगे बढ़ेगी; नहीं तो आइटम स्तर शून्य पर लौट जाएगा।",
  "study.repeat.label": "आपका उत्तर, फिर से",
  "study.repeat.submit": "दोहराएँ",
  "study.repeat.selfGrade": "इसके बजाय खुद ग्रेड दें",
  "study.repeat.evalTitle": "आपका दोहराव",
  "error.generic": "कुछ गड़बड़ हो गई। कृपया फिर से कोशिश करें।",
  "error.transport": "सर्वर तक नहीं पहुँच पा रहे। अपना कनेक्शन जाँचें और फिर कोशिश करें।",
  "error.session": "आपका सत्र समाप्त हो गया है। कृपया फिर से साइन इन करें।",
  "error.validation": "दर्ज की गई कुछ जानकारी मान्य नहीं है।",
  "error.notFound": "यह आइटम अब मौजूद नहीं है।",
  "error.tooLarge": "यह फ़ाइल बहुत बड़ी है।",
  "error.unsupported": "यह फ़ाइल प्रकार समर्थित नहीं है। PDF, Word, PowerPoint, टेक्स्ट या Markdown फ़ाइलें इस्तेमाल करें।",
  "error.aiNotConfigured": "सर्वर पर AI अभी सेट नहीं है।",
  "error.aiUnavailable": "AI अस्थायी रूप से उपलब्ध नहीं है। कृपया बाद में कोशिश करें।",
  "error.aiInvalid": "AI ने उपयोग लायक जवाब नहीं दिया। कृपया फिर से कोशिश करें।",
  "error.state": "वर्तमान स्थिति में यह कार्रवाई संभव नहीं है।",
  "error.server": "सर्वर पर कुछ गड़बड़ हो गई। कृपया फिर से कोशिश करें।",
  "error.rateLimited": "बहुत ज़्यादा कोशिशें हुईं। थोड़ा रुककर फिर कोशिश करें।",
  "error.managedCourse": "यह कोर्स मार्केटप्लेस से है: इसका लेखक इसे अपडेट रखता है, इसलिए यहाँ इसकी सामग्री नहीं बदली जा सकती।",
  "studyState.NOT_STUDIED": "पढ़ा नहीं",
  "studyState.STUDIED": "पढ़ लिया",
  "studyState.ACTIVE": "सक्रिय",
  "studyState.PAUSED": "रुका हुआ",
  "studyState.COMPLETED": "पूरा हुआ",
  "memoryState.NEW": "नया",
  "memoryState.LEARNING": "सीख रहे हैं",
  "memoryState.REVIEW": "समीक्षा में",
  "memoryState.RELEARNING": "फिर से सीख रहे हैं",
  "memoryState.MASTERED": "पक्का हुआ",
  "outcome.AGAIN": "फिर से",
  "outcome.HARD": "कठिन",
  "outcome.GOOD": "अच्छा",
  "outcome.EASY": "आसान",
  "outcomeHelp.AGAIN": "मुझे नहीं पता था",
  "outcomeHelp.HARD": "मुझे पता था, पर मुश्किल से",
  "outcomeHelp.GOOD": "मुझे पता था",
  "outcomeHelp.EASY": "मुझे आसानी से पता था",
  "classification.CORRECT": "सही",
  "classification.PARTIALLY_CORRECT": "आंशिक रूप से सही",
  "classification.MISCONCEPTION": "गलत धारणा",
  "classification.WRONG": "सही नहीं",
  "classification.UNCERTAIN": "अनिश्चित",
  "role.CORE_TRAINABLE": "मुख्य",
  "role.SUPPORTING_TRAINABLE": "सहायक",
  "role.COMMON_TRAP": "आम जाल",
  "role.INFORMATIONAL": "जानकारी",
  "role.REFERENCE": "संदर्भ",
  "role.OPTIONAL_EXTENSION": "वैकल्पिक",
  "priority.1": "अनिवार्य",
  "priority.2": "महत्वपूर्ण",
  "priority.3": "अतिरिक्त",
  "label.page": "पृष्ठ {n}",
  "label.pages": "पृष्ठ {a}–{b}",
  "label.pageShort": "पृ. {n}",
  "label.pagesShort": "पृ. {a}–{b}",
  "category.law": "कानून",
  "category.economics_business": "अर्थशास्त्र और व्यापार",
  "category.accounting_finance": "लेखा और वित्त",
  "category.medicine_health": "चिकित्सा और स्वास्थ्य",
  "category.sciences": "विज्ञान",
  "category.mathematics": "गणित",
  "category.engineering": "इंजीनियरिंग",
  "category.computer_science": "कंप्यूटर विज्ञान",
  "category.languages": "भाषाएँ",
  "category.humanities": "इतिहास और मानविकी",
  "category.arts": "कला और संगीत",
  "category.professional_exams": "पेशेवर परीक्षाएँ",
  "category.other": "अन्य",
  "level.all": "सभी स्तर",
  "level.beginner": "शुरुआती",
  "level.intermediate": "मध्यम",
  "level.advanced": "उन्नत",
  "size.small": "छोटा (50 से कम सवाल)",
  "size.medium": "मध्यम (50–299 सवाल)",
  "size.large": "बड़ा (300+ सवाल)",
  "sort.popular": "सबसे ज़्यादा लिए गए",
  "sort.newest": "नवीनतम",
  "sort.largest": "सबसे ज़्यादा सवाल",
  "lang.it": "इतालवी",
  "lang.en": "अंग्रेज़ी",
  "price.free": "मुफ़्त",
  "common.loading": "लोड हो रहा है…",
  "common.tryAgain": "फिर कोशिश करें",
  "common.dismiss": "हटाएँ",
  "common.delete": "हटाएँ",
  "common.edit": "बदलें",
  "common.rename": "नाम बदलें",
  "common.title": "शीर्षक",
  "common.description": "विवरण",
  "common.continue": "जारी रखें",
  "common.search": "खोजें",
  "common.add": "जोड़ें",
  "common.remove": "हटाएँ",
  "common.yes": "हाँ",
  "common.no": "नहीं",
  "common.collapse": "{label} को समेटें",
  "common.expand": "{label} को फैलाएँ",
  "drag.item": "आइटम",
  "drag.reorder": "{label} का क्रम बदलें",
  "drag.pickedUp": "{label} उठाया, {total} में से स्थिति {pos}।",
  "drag.over": "{label} अब {total} में से स्थिति {pos} पर है।",
  "drag.dropped": "{label} को {total} में से स्थिति {pos} पर रखा।",
  "drag.droppedPlain": "{label} रख दिया।",
  "drag.cancelled": "{label} को ले जाना रद्द किया गया।",
  "drawing.loadFailed": "चित्र लोड नहीं हो सका।",
  "course.authorOrder": "इस कोर्स का क्रम लेखक तय करता है।",
  "priority.yours": "आपकी प्राथमिकता",
  "priority.label": "प्राथमिकता",
  "priority.author": "लेखक: {name}",
  "priority.useAuthor": "लेखक वाली इस्तेमाल करें",
  "editTitle.rename": "{label} का नाम बदलें",
  "label.course": "कोर्स",
  "label.chapter": "अध्याय",
  "label.topic": "विषय",
  "label.concept": "अवधारणा",
  "library.heading": "मेरे कोर्स",
  "library.count.one": "{n} कोर्स",
  "library.count.other": "{n} कोर्स",
  "library.shownOf": "{total} में से {shown} दिखाए गए",
  "library.search": "कोर्स खोजें",
  "library.show": "दिखाएँ",
  "library.sortBy": "क्रमबद्ध करें",
  "library.new": "+ नया कोर्स",
  "library.marketplace": "🛒 मार्केटप्लेस",
  "library.empty": "अभी कोई कोर्स नहीं है। एक बनाएँ, फिर अपनी पढ़ाई की सामग्री या अपने सवाल-जवाब जोड़ें।",
  "library.createFirst": "अपना पहला कोर्स बनाएँ",
  "library.noMatch": "इस खोज या फ़िल्टर से कोई कोर्स मेल नहीं खाता।",
  "libStatus.all": "सभी कोर्स",
  "libStatus.in_progress": "जारी",
  "libStatus.not_started": "शुरू नहीं हुए",
  "libStatus.due": "बाकी समीक्षाएँ",
  "libStatus.completed": "सीखने को कुछ नया नहीं",
  "libStatus.paused": "रुके हुए",
  "libStatus.archived": "संग्रहीत",
  "libSort.recent_study": "हाल में पढ़े",
  "libSort.recent_created": "हाल में बने",
  "libSort.alphabetical": "वर्णानुक्रम",
  "libSort.most_due": "सबसे ज़्यादा बाकी समीक्षाएँ",
  "card.marketplacePill": "🛒 मार्केटप्लेस से · {author} द्वारा",
  "card.marketplaceHint": "लेखक सामग्री को अपडेट रखता है; आपकी पढ़ाई आपकी अपनी है।",
  "card.continue": "जारी रखें",
  "card.next": "अगला",
  "card.archived": "संग्रहीत",
  "card.paused": "रुका हुआ",
  "card.conceptsStudied": "अवधारणाएँ पढ़ी गईं",
  "card.itemsIntroduced": "सीखने की इकाइयाँ शुरू हुईं",
  "card.moreFor": "{title} के लिए और",
  "menu.details": "कोर्स का विवरण",
  "menu.material": "पढ़ाई की सामग्री",
  "menu.progress": "प्रगति",
  "menu.publish": "🛒 मार्केटप्लेस पर प्रकाशित करें",
  "menu.pause": "रोकें",
  "menu.resume": "फिर शुरू करें",
  "menu.archive": "संग्रहित करें",
  "menu.restore": "वापस लाएँ",
  "menu.delete": "हटाएँ…",
  "menu.confirmOwn": "\"{title}\" हटाएँ? इसके अध्याय, सवाल, सामग्री और आपके जवाब हमेशा के लिए हट जाएँगे। सब कुछ रखने के लिए इसे संग्रहित करें।",
  "menu.confirmMarketplace": "\"{title}\" हटाएँ? आप इसे मार्केटप्लेस से मुफ़्त में फिर जोड़ सकते हैं।",
  "newCourse.aria": "नया कोर्स",
  "newCourse.language": "सामग्री की भाषा",
  "newCourse.create": "कोर्स बनाएँ",
  "learn.resume.label": "अभ्यास फिर शुरू करें",
  "learn.resume.hint": "अधूरा छोड़ा गया राउंड जारी रखें",
  "learn.study.label": "अगला सीखें",
  "learn.study.hint": "{title} पढ़ें",
  "learn.study.hintNone": "नई सामग्री सीखें",
  "learn.activate.label": "सीखना शुरू करें",
  "learn.activate.hint": "{title} के सवाल तैयार करें और पढ़ना शुरू करें",
  "learn.activate.hintNone": "अगली अवधारणा पढ़ना शुरू करें",
  "learn.setup.label": "सामग्री जोड़ें",
  "learn.setup.hint": "शुरू करने के लिए पढ़ाई की सामग्री या अपने सवाल जोड़ें",
  "learn.none.label": "सब सीख लिया ✓",
  "learn.none.hint": "इस कोर्स में सब कुछ सीखा जा चुका है",
  "review.none": "✓ अभी समीक्षा के लिए कुछ नहीं",
  "review.noneTitle": "इस कोर्स में अभी कुछ भी समीक्षा के लिए नहीं है",
  "review.aria.one": "{n} आइटम की समीक्षा करें",
  "review.aria.other": "{n} आइटम की समीक्षा करें",
  "review.button": "समीक्षा",
  "course.practiceHard": "कठिन सवालों का अभ्यास करें",
  "course.chapters": "अध्याय",
  "course.chaptersEmpty": "एक अध्याय जोड़ें, फिर उसमें पढ़ाई की सामग्री जोड़ें।",
  "course.chapterMeta": "{total} में से {active} अवधारणाएँ सक्रिय · महारत {mastery}",
  "course.newChapter": "नए अध्याय का शीर्षक",
  "course.addChapter": "अध्याय जोड़ें",
  "course.curriculum": "पाठ्यक्रम",
  "course.fallback": "कोर्स",
  "course.allMaterial": "सारी पढ़ाई की सामग्री",
  "course.manageQuestions": "सवाल प्रबंधित करें",
  "course.weakSpots": "जो आप बार-बार गलत करते हैं",
  "chapter.gone": "यह अध्याय अब मौजूद नहीं है।",
  "chapter.topics": "विषय",
  "chapter.starting": "विश्लेषण शुरू हो रहा है…",
  "chapter.analyze": "नई सामग्री का विश्लेषण करें",
  "chapter.analyzeHint": "AI अभी तक न जाँची गई सामग्री से विषय और अवधारणाएँ सुझाता है। कुछ भी बदलने से पहले आप सुझाव की समीक्षा करते हैं।",
  "chapter.noMaterial": "इस अध्याय में विश्लेषण के लिए कोई नई सामग्री नहीं है। पहले सामग्री अपलोड करें।",
  "chapter.empty": "अभी कोई विषय नहीं है। नीचे सामग्री अपलोड करें, फिर उसका विश्लेषण करें।",
  "chapter.topicMeta": "{total} में से {active} अवधारणाएँ सक्रिय",
  "topic.gone": "यह विषय अब मौजूद नहीं है।",
  "topic.concepts": "अवधारणाएँ",
  "topic.empty": "इस विषय में कोई अवधारणा नहीं है।",
  "topic.needsReview": "स्रोत की समीक्षा चाहिए",
  "topic.conceptMeta": "{state} · महारत {mastery}",
  "unit.item.one": "{n} आइटम",
  "unit.item.other": "{n} आइटम",
  "unit.answer.one": "{n} जवाब",
  "unit.answer.other": "{n} जवाब",
  "consolidate.continue": "दृढ़ीकरण जारी रखें",
  "consolidate.unfinished": "आपका {items} का समूह अधूरा है: {left} बाकी। जो उत्तर आप दे चुके हैं वे सुरक्षित हैं।",
  "consolidate.resume": "फिर शुरू करें",
  "consolidate.doneTitle": "दृढ़ हो गया",
  "consolidate.doneBody": "इस अवधारणा के हर आइटम के दृढ़ीकरण राउंड हो चुके हैं। समय आने पर वे आपकी समीक्षाओं में लौटेंगे।",
  "consolidate.title": "क्या आपने यह अवधारणा पढ़ ली?",
  "consolidate.body": "पहले ऊपर पढ़ें कि क्या सीखना है। तैयार होने पर, हर प्रश्न तब तक पूछा जाता है जब तक आप उसे {n} बार अच्छी तरह न दे दें (लगातार होना ज़रूरी नहीं), हर उत्तर के बाद प्रतिक्रिया के साथ।",
  "consolidate.batch": "यह बैच: {items} · {answers}",
  "consolidate.more.one": "{n} और आइटम बाद के बैच का इंतज़ार कर रहा है",
  "consolidate.more.other": "{n} और आइटम बाद के बैच का इंतज़ार कर रहे हैं",
  "consolidate.button": "मैंने यह अवधारणा पढ़ ली",
  "breadcrumb.aria": "ब्रेडक्रम्ब",
  "dash.title": "डैशबोर्ड",
  "dash.loading": "आपका डैशबोर्ड लोड हो रहा है…",
  "dash.aside": "आपकी पढ़ाई",
  "dash.today": "आज",
  "dash.xpTodayPlus": "आज +{n} XP",
  "dash.goal": "लक्ष्य {done}/{target}",
  "dash.tzNote": "आपके पढ़ाई के दिन (लगातार दिन, लक्ष्य, आज के XP) {zone} के अनुसार चलते हैं। यह डिवाइस {device} में है।",
  "dash.tzUse": "{zone} इस्तेमाल करें",
  "next.title": "आपका अगला कदम",
  "next.resumeTitle": "समेकन जारी रखें · अच्छा उत्तर {round} / {total}",
  "next.answersLeft": "{n} जवाब बाकी",
  "next.resume": "फिर शुरू करें",
  "next.minutes": "लगभग {n} मिनट",
  "next.startReview": "समीक्षा शुरू करें",
  "next.learnTitle": "सीखना जारी रखें: {concept}",
  "next.nextConcept": "अगली अवधारणा",
  "next.learn": "सीखें",
  "next.setupTitle": "{concept} तैयार करें",
  "next.theNextConcept": "अगली अवधारणा",
  "next.setupDetail": "{course} · इसके सवाल तैयार करने के लिए सक्रिय करें",
  "next.setup": "तैयार करें",
  "next.addMaterialTitle": "{course} में सामग्री जोड़ें",
  "next.yourCourse": "आपका कोर्स",
  "next.addMaterialDetail": "इसकी अवधारणाएँ बनाने के लिए पढ़ाई की सामग्री या अपने सवाल-जवाब अपलोड करें।",
  "next.firstCourse": "अपना पहला कोर्स शुरू करें",
  "next.firstCourseDetail": "एक कोर्स बनाएँ, फिर सामग्री या अपने सवाल जोड़ें।",
  "next.caughtUp": "आप पूरी तरह अप-टू-डेट हैं",
  "next.caughtUpDetail": "कुछ भी बाकी नहीं है और कोई नई सामग्री इंतज़ार में नहीं है।",
  "streak.title": "दैनिक सिलसिला",
  "streak.unit.one": "दिन",
  "streak.unit.other": "दिन",
  "streak.done": "आज पूरा हुआ। जारी रखने के लिए कल लौटें।",
  "streak.keep": "अपना सिलसिला बनाए रखने के लिए आज एक सवाल का जवाब दें।",
  "streak.start": "सिलसिला शुरू करने के लिए आज एक सवाल का जवाब दें।",
  "streak.last7": "पिछले 7 दिन",
  "streak.studied": "पढ़ा",
  "streak.noStudy": "पढ़ाई नहीं",
  "xp.title": "अनुभव",
  "xp.how": "XP कैसे काम करता है",
  "xp.howBody": "एक ही आइटम के हर सही जवाब पर ज़्यादा XP मिलते हैं: पहली बार 10, फिर 20, 30… 150 तक। संकेत लेने पर उस जवाब के XP आधे हो जाते हैं। गलत जवाब पर कुछ नहीं मिलता पर आपकी प्रगति रीसेट नहीं होती। XP अभ्यास को इनाम देते हैं; वे आपकी समीक्षा अनुसूची कभी नहीं बदलते।",
  "goal.title": "दैनिक लक्ष्य",
  "goal.sr": "दैनिक लक्ष्य: आज {target} में से {done} जवाब पूरे हुए, {percent} प्रतिशत।",
  "goal.answersToday": "आज {done} / {target} जवाब",
  "goal.perDay": "प्रतिदिन जवाब",
  "goal.edit": "लक्ष्य बदलें",
  "goal.invalid": "1 से 500 के बीच कोई पूर्ण संख्या चुनें।",
  "planner.title": "समय योजनाकार",
  "planner.now": "अभी",
  "planner.1h": "1 घंटे में",
  "planner.4h": "4 घंटे में",
  "planner.1d": "1 दिन में",
  "planner.3d": "3 दिन में",
  "planner.7d": "7 दिन में",
  "planner.dueNow": "अभी {n} बाकी: लगभग {min} मिनट",
  "planner.caption": "हर समय तक बाकी समीक्षाएँ, देर वाली भी शामिल",
  "planner.dueBy": "तक बाकी",
  "planner.items": "आइटम",
  "planner.hint": "आपकी वर्तमान समीक्षा अनुसूची पर आधारित; पढ़ाई के साथ बदलती है। हर पंक्ति में उससे पहले का सब कुछ शामिल है।",
  "activity.title": "गतिविधि",
  "activity.seeMore": "और देखें",
  "activity.future": "{day}: भविष्य में",
  "activity.day": "{day}: {answers}",
  "activity.dayXp": "{day}: {answers}, {xp} XP",
  "activity.aria": "गतिविधि कैलेंडर: {days}, {answers}",
  "activity.summary": "{days} · {answers}",
  "unit.activeDay.one": "{n} सक्रिय दिन",
  "unit.activeDay.other": "{n} सक्रिय दिन",
  "activity.less": "कम",
  "activity.more": "ज़्यादा",
  "activity.legendFuture": "भविष्य",
  "pb.curriculumHint": "आपने कितनी सामग्री पढ़ी और सक्रिय की है।",
  "pb.conceptsActive": "सक्रिय अवधारणाएँ",
  "pb.activeOf": "{total} में से {active}",
  "pb.memory": "स्मृति",
  "pb.memoryHint": "आप जो अभ्यास करते हैं उसे कितना याद रखते हैं। महारत आपकी समीक्षाओं से लगाया गया अनुमान है।",
  "pb.mastery": "महारत (अनुमान)",
  "pb.itemsTrained": "प्रशिक्षण में आइटम",
  "pb.markedHard": "कठिन चिह्नित",
  "pb.dueNow": "अभी बाकी",
  "pb.laterToday": "आज बाद में",
  "pb.tomorrow": "कल",
  "pb.next7": "अगले 7 दिन",
  "pb.newToLearn": "सीखने के लिए नया",
  "pb.overdue.one": "{n} सवाल देर से है: उन्हीं से शुरू करें।",
  "pb.overdue.other": "{n} सवाल देर से हैं: उन्हीं से शुरू करें।",
  "pb.caption": "इस कोर्स में जल्द बाकी होने वाले सवाल और लगभग लगने वाला समय",
  "pb.when": "कब",
  "pb.questions": "सवाल",
  "pb.time": "समय",
  "pb.minutes": "~{n} मिनट",
  "study.intent.LEARN": "सीखें",
  "study.intent.SCHEDULED_REVIEW": "समीक्षा",
  "study.intent.PRACTICE": "अभ्यास",
  "study.intent.EXAM": "परीक्षा",
  "study.intent.CONSOLIDATION": "दृढ़ीकरण",
  "study.round": "अच्छा उत्तर {n} / {total}",
  "study.progressAria": "इस सत्र की प्रगति",
  "study.progress": "{total} में से {n}",
  "study.xpSessionAria": "इस सत्र में {n} XP",
  "study.ownReview": "अपनी समीक्षा: योजना में कोई बदलाव नहीं, कोई XP नहीं",
  "study.leaveResume": "छोड़ें (बाद में जारी रखें)",
  "study.end": "सत्र समाप्त करें",
  "study.preparing": "आपका सत्र तैयार हो रहा है…",
  "study.empty.title": "अभी पढ़ने के लिए कुछ नहीं",
  "study.empty.body": "इस सत्र के लिए कुछ उपयुक्त नहीं है। नई सामग्री जोड़ने के लिए कोई अवधारणा सक्रिय करें, या समीक्षाएँ बाकी होने पर लौटें।",
  "study.empty.back": "कोर्स पर वापस जाएँ",
  "study.newMaterial": "नई सामग्री",
  "study.keyPoints": "मुख्य बिंदु",
  "study.sources": "स्रोत",
  "study.ready": "मैं तैयार हूँ: मेरी परीक्षा लें",
  "study.answering": "जवाब देना",
  "study.drawHint": "अपना जवाब नीचे बनाएँ। AI उसकी तुलना संदर्भ चित्र से करता है।",
  "study.note": "नोट (वैकल्पिक)",
  "study.yourAnswer": "आपका जवाब",
  "study.notePlaceholder": "अपने चित्र में कुछ जोड़ना हो तो…",
  "study.answerPlaceholder": "अपने शब्दों में जवाब दें…",
  "study.stopListening": "सुनना बंद करें",
  "study.speak": "अपना जवाब बोलें",
  "study.evaluating": "मूल्यांकन हो रहा है…",
  "study.submit": "जमा करें",
  "study.skip": "यह सवाल छोड़ें",
  "study.dictationOn": "डिक्टेशन आपका ब्राउज़र लिखित रूप में बदलता है और वह ऑडियो अपनी स्पीच सेवा को भेज सकता है। केवल टेक्स्ट रखा जाता है; जमा करने से पहले उसे बदलें।",
  "study.dictationOff": "आवाज़ से जवाब देने के लिए Chrome, Edge या Safari चाहिए। आप यहाँ टाइप कर सकते हैं।",
  "study.drawingCompare": "आपका चित्र और संदर्भ",
  "study.yourDrawing": "आपका चित्र",
  "study.reference": "संदर्भ",
  "study.gradedByYou": "आपने ग्रेड दिया",
  "study.needsGrade": "आपके ग्रेड की ज़रूरत है",
  "study.firstEval": "पहला मूल्यांकन",
  "study.secondOpinion": "दूसरी राय",
  "study.afterObjection": "आपकी आपत्ति के बाद: “{text}”",
  "study.referenceSummary": "संदर्भ उत्तर और स्रोत",
  "study.studyConcept": "📖 यह अवधारणा पढ़ें",
  "study.gradeHow": "आप इसे कितना जानते थे?",
  "study.gradeYourself": "या खुद ग्रेड दें",
  "study.yourGrade": "आपका ग्रेड",
  "study.retryEval": "मूल्यांकन फिर आज़माएँ",
  "study.skipNow": "अभी छोड़ें",
  "study.disagree": "ग्रेड से असहमत हैं?",
  "study.notMemorized": "अभी याद नहीं हुआ: यह इसी सत्र में फिर दिखेगा।",
  "study.levelNext": "स्तर {from} → {to}। अगली समीक्षा: {when}",
  "study.practiceNote": "अभ्यास आपकी समीक्षा अनुसूची नहीं बदलता।",
  "study.complete": "सत्र पूरा हुआ",
  "study.xpSessionPlus": "इस सत्र में +{n} XP",
  "study.answeredIn": "{answers} लगभग {min} मिनट में।",
  "study.wentWell": "{n} अच्छे रहे।",
  "study.steady": "लगातार मेहनत: यह जमता जा रहा है।",
  "study.comeBack": "जो अच्छे नहीं रहे वे जल्द लौटेंगे, इसी तरह वे याद रहते हैं।",
  "study.stillDue": "अभी भी बाकी: {n} (लगभग {min} मिनट)।",
  "study.nothingDue": "अभी कुछ और बाकी नहीं है।",
  "study.done": "हो गया",
  "study.noXp": "इस जवाब पर XP नहीं मिलता (अभ्यास, या समीक्षा का समय नहीं आया)।",
  "study.correctXp": "सही जवाब: +{n} XP",
  "study.halfXp": "(संकेत लिया: आधे XP)",
  "study.hintLabel": "संकेत",
  "study.noHint": "इस सवाल के लिए कोई संकेत नहीं है।",
  "study.showHint": "संकेत दिखाएँ",
  "study.hintHalves": "संकेत लेने पर इस जवाब के XP आधे हो जाते हैं।",
  "study.revealHint": "संकेत खोलें",
  "study.plusZero": "+0 XP",
  "study.onlyCorrectSelf": "केवल सही जवाबों पर XP मिलते हैं: आपका अपना कठिन, अच्छा या आसान भी गिना जाता है।",
  "study.onlyCorrect": "केवल पूरी तरह सही जवाबों पर XP मिलते हैं। अगले इनाम की ओर आपकी प्रगति सुरक्षित रहती है।",
  "study.awardCorrect": "सही",
  "study.awardHint": "संकेत लिया",
  "study.ordinal": "इस आइटम का सही जवाब #{n}",
  "study.ordinalHalf": "इस आइटम का सही जवाब #{n}, {base} का आधा",
  "study.batchDone": "बैच दृढ़ हो गया",
  "study.correctAnswers": "सही जवाब",
  "study.xpThisSession": "इस सत्र के XP",
  "study.whatNext": "आगे क्या होगा",
  "study.whatNextBody": "जिन आइटम का आखिरी राउंड सही रहा वे लगभग 4 घंटे में समीक्षा में लौटते हैं; बाकी अगले बैच का इंतज़ार करते हैं।",
  "study.waiting.one": "{n} और आइटम इंतज़ार में है",
  "study.waiting.other": "{n} और आइटम इंतज़ार में हैं",
  "study.batchNotAll": "यह बैच पूरा हुआ, पूरी अवधारणा नहीं: {waiting}।",
  "study.allRounds": "इस अवधारणा की प्रतीक्षा कर रही हर इकाई को तीन बार अच्छा उत्तर मिल चुका है।",
  "study.nextBatch": "अगला बैच",
  "study.conceptCosts": "अभी अवधारणा देखना संकेत लेने जैसा है: इस जवाब पर आधे XP मिलेंगे।",
  "study.openConcept": "अवधारणा खोलें",
  "study.dontRemember": "📖 याद नहीं? यह अवधारणा पढ़ें",
  "study.refDrawing": "संदर्भ चित्र",
  "dispute.title": "AI से फिर देखने को कहें",
  "dispute.testAi": "टेस्ट AI आपकी आपत्ति नहीं पढ़ सकता: दूसरी राय वही ग्रेड दोहराएगी। नीचे खुद ग्रेड दें।",
  "dispute.why": "आप असहमत क्यों हैं?",
  "dispute.placeholder": "बताएँ कि मूल्यांकन में क्या गलत था…",
  "dispute.hint": "AI आपकी आपत्ति देखकर फिर मूल्यांकन करता है। दोनों राय दिखती रहती हैं; आपका ग्रेड तभी बदलता है जब आप नीचे चुनें।",
  "dispute.asking": "पूछ रहे हैं…",
  "dispute.ask": "दूसरी राय माँगें",
  "eval.correct": "सही",
  "eval.complete": "पूर्ण",
  "eval.understanding": "समझ",
  "eval.precise": "सटीक",
  "eval.Strong": "मज़बूत",
  "eval.Partial": "आंशिक",
  "eval.Weak": "कमज़ोर",
  "eval.scoreBreakdown": "अंकों का विवरण",
  "eval.right": "सही",
  "eval.missing": "छूटा",
  "eval.misconception": "गलत धारणा",
  "eval.materialSays": "सामग्री कहती है",
  "eval.covered": "आपके जवाब ने क्या कवर किया",
  "eval.failed": "जवाब का मूल्यांकन नहीं हो सका।",
  "eval.aiEvaluation": "AI मूल्यांकन: {verdict}",
  "eval.insufficient": "कोर्स की सामग्री इसे इतना कवर नहीं करती कि ग्रेड दिया जा सके।",
  "eval.testAiTitle": "टेस्ट AI।",
  "eval.testAiBody": "यह ग्रेड एक स्टैंड-इन से आया है जो केवल संदर्भ से शब्द मिलाता है: वह पैराफ़्रेज़ या आपत्तियाँ नहीं समझता। संदर्भ देखकर खुद ग्रेड दें, या असली AI जोड़ें।",
  "conceptPanel.title": "यह अवधारणा पढ़ें",
  "conceptPanel.next": "पढ़ लिया — अगला प्रश्न",
  "conceptPanel.closeAria": "अवधारणा बंद करें",
  "conceptPanel.loading": "अवधारणा लोड हो रही है…",
  "conceptPanel.openFull": "अवधारणा का पूरा पेज नए टैब में खोलें",
  "dictation.blocked": "माइक्रोफ़ोन ब्लॉक है। डिक्टेशन के लिए इसे अपने ब्राउज़र की साइट सेटिंग्स में अनुमति दें।",
  "dictation.network": "स्पीच रिकग्निशन के लिए इंटरनेट कनेक्शन चाहिए।",
  "dictation.noMic": "कोई माइक्रोफ़ोन नहीं मिला।",
  "dictation.stopped": "स्पीच रिकग्निशन अचानक रुक गया। आप टाइप करना जारी रख सकते हैं।",
  "concept.activate": "सक्रिय करें",
  "concept.activateHelp": "आपकी सामग्री से इस अवधारणा के सवाल तैयार करता है ताकि आप इसे पढ़ सकें।",
  "concept.markStudied": "पढ़ा हुआ चिह्नित करें",
  "concept.markStudiedHelp": "आपने इसे कहीं और पढ़ा: यह दर्ज हो जाता है, अभी सवाल तैयार नहीं होते।",
  "concept.activateAgainHelp": "इसे फिर से पढ़ता है: इसके सवाल आपके सत्रों में लौट आते हैं।",
  "concept.pause": "रोकें",
  "concept.pauseHelp": "कुछ समय के लिए इसके सवाल रोकता है। कुछ भी नहीं खोता।",
  "concept.deactivate": "निष्क्रिय करें",
  "concept.deactivateHelp": "इसे पढ़ाई और समीक्षाओं से हटाता है। आपके जवाब और इतिहास सुरक्षित रहते हैं।",
  "concept.resume": "फिर शुरू करें",
  "concept.resumeHelp": "इसके सवाल पढ़ाई और समीक्षाओं में वापस लाता है।",
  "concept.sourceDeleted": "इस अवधारणा की मूल सामग्री हटा दी गई है। इसे रखें, बदलें या हटाएँ।",
  "concept.manage": "इस अवधारणा को प्रबंधित करें",
  "concept.loadingItems": "सीखने की इकाइयाँ लोड हो रही हैं…",
  "concept.preparing": "सीखने की इकाइयाँ तैयार हो रही हैं…",
  "concept.itemsFailed": "सीखने की इकाइयाँ तैयार नहीं हो सकीं।",
  "concept.noSource": "इस अवधारणा के पास सीखने की इकाइयाँ बनाने के लिए कोई स्रोत सामग्री नहीं है।",
  "concept.whatToStudy": "क्या पढ़ें",
  "concept.reviewOwnHelp": "जब चाहें इस अवधारणा पर अपनी परीक्षा लें। इससे आपकी समीक्षा योजना नहीं बदलती और XP नहीं मिलते।",
  "concept.reviewOwn": "🔁 खुद समीक्षा करें",
  "concept.readThen": "इन्हें पढ़ें, फिर अभ्यास के लिए नीचे \"मैंने यह अवधारणा पढ़ ली\" दबाएँ।",
  "concept.testMe": "🔁 इस पर मेरी परीक्षा लें",
  "concept.hideDetails": "विवरण छिपाएँ",
  "concept.details": "विवरण",
  "concept.level": "स्तर {n}",
  "concept.markedHard": "कठिन चिह्नित",
  "concept.notTraining": "प्रशिक्षण में नहीं",
  "concept.state": "स्थिति",
  "concept.levelLabel": "स्तर",
  "concept.nextReview": "अगली समीक्षा",
  "concept.reviews": "समीक्षाएँ",
  "concept.lapses": "भूलें",
  "concept.inTraining": "प्रशिक्षण में",
  "concept.questions": "सवाल",
  "concept.sourcesTitle": "स्रोत",
  "concept.loadingSources": "स्रोत लोड हो रहे हैं…",
  "concept.noSources": "कोई स्रोत अंश नहीं है।",
  "concept.misconceptions": "बार-बार होने वाली गलत धारणाएँ",
  "drawing.answerBy": "चित्र बनाकर जवाब दें",
  "drawing.studentsDraw": "विद्यार्थी इस सवाल का जवाब चित्र बनाकर देते हैं। AI उनके चित्र की तुलना इससे करता है।",
  "drawing.youDraw": "आप इस सवाल का जवाब चित्र बनाकर देते हैं। AI आपके चित्र की तुलना इससे करता है।",
  "drawing.referenceAlt": "संदर्भ चित्र",
  "drawing.explain": "चित्र से हल होने वाले सवालों (अणु, आरेख, ग्राफ़) के लिए सही चित्र जोड़ें; विद्यार्थी लिखने की जगह अपना जवाब बनाएँगे।",
  "drawing.save": "यह चित्र सहेजें",
  "drawing.replace": "छवि से बदलें…",
  "drawing.upload": "चित्र अपलोड करें…",
  "drawing.drawNew": "नया बनाएँ",
  "drawing.drawHere": "यहाँ बनाएँ",
  "drawing.words": "इसके बजाय शब्दों में जवाब दें",
  "drawing.tools": "चित्र बनाने के औज़ार",
  "drawing.pen": "✏️ कलम",
  "drawing.eraser": "🧽 रबर",
  "drawing.thick": "मोटी रेखा",
  "drawing.thin": "पतली रेखा",
  "drawing.undo": "↶ पूर्ववत करें",
  "drawing.clear": "साफ़ करें",
  "drawing.area": "चित्र क्षेत्र: अपना जवाब यहाँ बनाएँ",
  "drawing.photoUpload": "कागज़ पर बनाया? इसके बजाय फ़ोटो अपलोड करें",
  "drawing.photoError": "यह फ़ाइल ऐसी छवि नहीं है जिसे यह ब्राउज़र पढ़ सके। JPEG या PNG फ़ोटो आज़माएँ।",
  "drawing.photoAlt": "चित्र की आपकी फ़ोटो",
  "drawing.drawInstead": "इसके बजाय बनाएँ",
  "q.title": "सवाल",
  "q.introOwn": "सवाल चुनकर उन्हें हटाएँ, रोकें, फिर शुरू करें या ले जाएँ; क्रम बदलने के लिए ⠿ खींचें; किसी का शीर्षक, शब्दांकन या अपेक्षित जवाब ठीक करने के लिए उसे बदलें।",
  "q.introManaged": "यह कोर्स मार्केटप्लेस से है: इसके सवाल लेखक अपडेट रखता है। सवाल चुनकर उन्हें रोकें या फिर शुरू करें, या उन्हें अपनी प्राथमिकता दें (केवल आप देखते हैं)।",
  "q.search": "सवाल खोजें",
  "q.searchPlaceholder": "सवाल और जवाब खोजें",
  "q.allPriorities": "सभी प्राथमिकताएँ",
  "q.priorityOnly": "केवल {label} ({n})",
  "q.deselectAll": "सभी का चयन हटाएँ",
  "q.selectAll": "सभी चुनें ({n})",
  "q.selectAllShown": "दिखाए गए सभी चुनें ({n})",
  "q.collapseAll": "सब समेटें",
  "q.expandAll": "सब फैलाएँ",
  "q.selectedAria": "चुने गए सवाल",
  "q.selectedCount": "{n} चुने गए",
  "q.moveTo": "यहाँ ले जाएँ…",
  "q.setPriority": "प्राथमिकता तय करें",
  "q.setPriorityPlaceholder": "प्राथमिकता तय करें…",
  "q.reviewSelectedHelp": "चुने हुए सवालों पर अभी अपनी परीक्षा लें। इससे आपकी समीक्षा योजना नहीं बदलती और XP नहीं मिलते।",
  "q.clearSelection": "चयन हटाएँ",
  "q.verb.delete": "हटाए गए",
  "q.verb.pause": "रोके गए",
  "q.verb.resume": "फिर शुरू किए गए",
  "q.verb.move": "ले जाए गए",
  "q.verb.set_priority": "अपडेट किए गए",
  "unit.question.one": "{n} सवाल",
  "unit.question.other": "{n} सवाल",
  "unit.chapter.one": "{n} अध्याय",
  "unit.chapter.other": "{n} अध्याय",
  "unit.topic.one": "{n} विषय",
  "unit.topic.other": "{n} विषय",
  "unit.concept.one": "{n} अवधारणा",
  "unit.concept.other": "{n} अवधारणाएँ",
  "unit.group.one": "{n} खाली हुआ समूह",
  "unit.group.other": "{n} खाली हुए समूह",
  "q.newConcepts.one": "{n} नई अवधारणा",
  "q.newConcepts.other": "{n} नई अवधारणाएँ",
  "q.removedConcepts.one": "{n} खाली अवधारणा हटाई गई",
  "q.removedConcepts.other": "{n} खाली अवधारणाएँ हटाई गईं",
  "q.noticeBulk": "{verb} {questions}{extra}।",
  "q.noticeDeleted": "{questions} हटाए गए।",
  "q.noticeDeletedGroups": "{questions} और {groups} हटाए गए।",
  "q.confirmDelete": "{questions} हटाएँ? उनके जवाब और समीक्षा का इतिहास भी हट जाएगा।{also}",
  "q.confirmAlso": " बिना सवाल बचे {groups} भी हट जाएँगे।",
  "q.emptySearch": "इस खोज से कोई सवाल मेल नहीं खाता।",
  "q.empty": "अभी कोई सवाल नहीं है। कोई अवधारणा सक्रिय करें या अपने सवाल-जवाब आयात करें।",
  "q.clearToReorder": "इन सवालों का क्रम बदलने के लिए खोज साफ़ करें।",
  "q.select": "चुनें: {text}",
  "q.otherWordings.one": "+{n} और शब्दांकन",
  "q.otherWordings.other": "+{n} और शब्दांकन",
  "q.editAria": "सवाल बदलें",
  "q.titleLabel": "शीर्षक (सूचियों में दिखता है)",
  "q.wordings": "सवाल के शब्दांकन",
  "q.wording": "शब्दांकन {n}",
  "q.addWording": "+ एक और शब्दांकन जोड़ें",
  "q.expected": "अपेक्षित जवाब",
  "q.prio1": "अनिवार्य: मूल, जानना ज़रूरी",
  "q.prio2": "महत्वपूर्ण: जानना चाहिए",
  "q.prio3": "अतिरिक्त: परिशिष्ट, गहरा विवरण",
  "q.keyPoints": "मुख्य बिंदु (हर पंक्ति में एक, अधिकतम 10)",
  "q.moveAria": "सवाल ले जाएँ",
  "q.moveHeading": "{questions} को यहाँ ले जाएँ",
  "q.choose": "कोई विषय या अवधारणा चुनें…",
  "q.topicOption": "विषय: {title} (हर सवाल अपनी अवधारणा रखता है)",
  "q.conceptOption": "   ↳ अवधारणा में: {title}",
  "q.removeEmpty": "बिना सवाल बची अवधारणाएँ हटाएँ",
  "q.moveHint": "सवाल अपनी समीक्षा प्रगति रखते हैं। निष्क्रिय अवधारणा में वे तब तक नहीं दोहराए जाते जब तक वह सक्रिय न हो।",
  "q.move": "ले जाएँ",
  "q.groupSelect": "{label} के सभी सवाल चुनें",
  "mat.chapterTitle": "अध्याय की सामग्री",
  "mat.collapseLabel": "पढ़ाई की सामग्री",
  "mat.files.one": "{n} फ़ाइल",
  "mat.files.other": "{n} फ़ाइलें",
  "mat.uploading": "अपलोड हो रहा है…",
  "mat.upload": "सामग्री अपलोड करें",
  "mat.uploadQa": "सवाल-जवाब अपलोड करें",
  "mat.paste": "टेक्स्ट चिपकाएँ",
  "mat.howTo": "सवाल-जवाब कैसे तैयार करें",
  "mat.howToBody": "PDF, Word, टेक्स्ट या Markdown फ़ाइल अपलोड करें जिसमें हर सवाल पंक्ति की शुरुआत में “Domanda:” से और उसका अपेक्षित जवाब “Risposta:” से (या “Question:” / “Answer:”) शुरू हो। शीर्षक सवालों को विषयों में बाँटते हैं।",
  "mat.howToBody2": "हर सवाल एक अवधारणा बन जाता है जिसे नहीं पढ़ा हुआ चिह्नित किया जाता है, और आपका जवाब अपेक्षित जवाब होता है। समीक्षा शुरू करने के लिए उसे सक्रिय करें। आयात में AI का उपयोग नहीं होता।",
  "mat.loading": "सामग्री लोड हो रही है…",
  "mat.none": "अभी कोई सामग्री नहीं है। PDF, Word, PowerPoint, टेक्स्ट या Markdown फ़ाइलें अपलोड करें।",
  "mat.file": "फ़ाइल",
  "mat.status": "स्थिति",
  "mat.passages": "अंश",
  "mat.added": "जोड़ा गया",
  "mat.actions": "कार्रवाइयाँ",
  "mat.qa": "सवाल-जवाब",
  "mat.processing": "प्रोसेस हो रहा है…",
  "mat.ready": "तैयार",
  "mat.failed": "विफल",
  "mat.download": "डाउनलोड",
  "mat.confirmDelete": "{name} हटाएँ? इससे बनी अवधारणाएँ समीक्षा के लिए चिह्नित होंगी।",
  "mat.pasteAria": "टेक्स्ट चिपकाएँ",
  "mat.pastePlaceholder": "जैसे: व्याख्यान 3 के नोट्स",
  "mat.thisTextIs": "यह टेक्स्ट है",
  "mat.asMaterial": "पढ़ाई की सामग्री",
  "mat.asQa": "सवाल-जवाब (Domanda: / Risposta:)",
  "mat.text": "टेक्स्ट",
  "mat.textPlaceholderQa": "# विषय\nDomanda: …?\nRisposta: …",
  "mat.textPlaceholder": "# शीर्षक\nआपके नोट्स…",
  "mat.adding": "जोड़ा जा रहा है…",
  "mat.addText": "टेक्स्ट जोड़ें",
  "mat.pastedName": "चिपकाया गया टेक्स्ट {when}",
  "prop.title": "प्रस्तावित पाठ्यक्रम",
  "prop.reading": "AI आपकी सामग्री पढ़ रहा है…",
  "prop.applied": "यह प्रस्ताव पहले ही लागू हो चुका है।",
  "prop.failed": "AI पाठ्यक्रम का प्रस्ताव नहीं दे सका।",
  "prop.blank": "हर अध्याय, विषय और अवधारणा का शीर्षक होना चाहिए।",
  "prop.longMaterial": "सामग्री लंबी थी: यह {total} में से पहले {used} अंशों को कवर करता है।",
  "prop.dropped": "प्रस्तावित {n} अवधारणाएँ छोड़ दी गईं क्योंकि उन्हें आपकी सामग्री से जोड़ा नहीं जा सका।",
  "prop.hint": "नीचे कुछ भी बदलें: नाम बदलें, क्रम बदलें, अवधारणाएँ विषयों के बीच ले जाएँ, मिलाएँ, हटाएँ या जोड़ें। कुछ भी सक्रिय नहीं होता: बाद में आप तय करते हैं कि क्या पढ़ना है।",
  "prop.chapterTitle": "अध्याय का शीर्षक",
  "prop.deleteChapter": "अध्याय हटाएँ",
  "prop.accept": "पाठ्यक्रम स्वीकार करें",
  "prop.reject": "प्रस्ताव अस्वीकार करें",
  "prop.topicAria": "विषय {title}",
  "prop.existingTopic": "मौजूदा विषय",
  "prop.topicTitle": "विषय का शीर्षक",
  "prop.moveTopicUp": "विषय ऊपर ले जाएँ",
  "prop.moveTopicDown": "विषय नीचे ले जाएँ",
  "prop.deleteTopic": "विषय हटाएँ",
  "prop.conceptTitle": "अवधारणा का शीर्षक",
  "prop.exists": "पहले से मौजूद",
  "prop.moveConceptUp": "अवधारणा ऊपर ले जाएँ",
  "prop.moveConceptDown": "अवधारणा नीचे ले जाएँ",
  "prop.moveToTopic": "विषय में ले जाएँ",
  "prop.untitled": "बिना शीर्षक का विषय",
  "prop.merge": "अगले से मिलाएँ",
  "prop.addConcept": "+ अवधारणा जोड़ें",
  "mkt.intro": "LEARNABLE के दूसरे उपयोगकर्ताओं के बनाए कोर्स। किसी को अपने कोर्स में जोड़ें और अपनी अनुसूची से पढ़ें: लेखक उसे अपडेट रखता है। अपना कोर्स साझा करने के लिए उसे खोलें और उसका “मार्केटप्लेस पेज” भरें।",
  "mkt.categories": "श्रेणियाँ",
  "mkt.all": "सभी",
  "mkt.searchPlaceholder": "शीर्षक या विवरण से खोजें",
  "mkt.level": "स्तर",
  "mkt.language": "भाषा",
  "mkt.size": "आकार",
  "mkt.sort": "क्रम",
  "mkt.any": "कोई भी",
  "mkt.loading": "कोर्स लोड हो रहे हैं…",
  "mkt.noMatch": "इन फ़िल्टरों से अभी कोई कोर्स मेल नहीं खाता।",
  "mkt.publishedByMe": "मेरे द्वारा प्रकाशित",
  "mkt.status.DRAFT": "ड्राफ़्ट",
  "mkt.status.PUBLISHED": "प्रकाशित",
  "mkt.status.UNPUBLISHED": "अप्रकाशित",
  "mkt.version": "संस्करण {n}",
  "mkt.students.one": "{n} विद्यार्थी",
  "mkt.students.other": "{n} विद्यार्थी",
  "mkt.editCourse": "कोर्स और उसका पेज बदलें",
  "mkt.by": "{author} द्वारा",
  "mkt.inYourCourses": "आपके कोर्स में",
  "mkt.loadingCourse": "कोर्स लोड हो रहा है…",
  "mkt.updated": "{date} को अपडेट",
  "mkt.statStudents": "विद्यार्थी",
  "mkt.yourCourse": "आपका कोर्स",
  "mkt.draftTag": "ड्राफ़्ट",
  "mkt.notPublishedTag": "अप्रकाशित",
  "mkt.open": "मेरे कोर्स में खोलें",
  "mkt.addBack": "मेरे कोर्स में फिर जोड़ें",
  "mkt.add": "मेरे कोर्स में जोड़ें · {price}",
  "mkt.about": "इस कोर्स के बारे में",
  "mkt.learn": "आप क्या सीखेंगे",
  "mkt.audience": "यह किसके लिए है",
  "mkt.hiddenNote": "कोर्स आपके कोर्स में आने पर सवाल और जवाब दिखते हैं। आप उन्हें LEARNABLE के अंदर पढ़ते हैं: लेखक की सामग्री डाउनलोड नहीं की जा सकती।",
  "sales.originTitle": "🛒 मार्केटप्लेस से",
  "sales.madeBy": "{author} द्वारा बनाया गया (संस्करण {version})। लेखक अध्याय, सवाल और जवाब अपडेट रखता है, इसलिए आप उन्हें यहाँ नहीं बदल सकते: अपडेट आपको अपने आप मिलते हैं।",
  "sales.yourStudy": "आपकी पढ़ाई आपकी अपनी है: अवधारणाएँ सक्रिय करना, रोकना, आपके जवाब, आपकी समीक्षा योजना और XP, और हर सवाल को दी गई आपकी प्राथमिकता (केवल आप देखते हैं)।",
  "sales.seePage": "इसका मार्केटप्लेस पेज देखें",
  "sales.title": "🛒 मार्केटप्लेस पेज",
  "sales.pPublished": "प्रकाशित · संस्करण {n}",
  "sales.pNot": "अप्रकाशित",
  "sales.pDraft": "ड्राफ़्ट",
  "sales.pNone": "साझा नहीं",
  "sales.explain": "इस कोर्स को दूसरे उपयोगकर्ताओं के साथ साझा करें। यहाँ आप उसका पेज लिखते हैं, जो जोड़ने से पहले लोगों को दिखने वाली एकमात्र चीज़ है: उसमें क्या है, वह किसके लिए है, वे क्या सीखेंगे। उन्हें अध्यायों के शीर्षक और सवालों की संख्या भी दिखती है; सवाल खुद केवल जोड़ने के बाद, और आपकी अपलोड की गई सामग्री कभी नहीं।",
  "sales.seeAsOthers": "दूसरों की तरह देखें",
  "sales.edit": "मार्केटप्लेस पेज बदलें",
  "sales.write": "मार्केटप्लेस पेज लिखें",
  "sales.subtitle": "उपशीर्षक",
  "sales.subtitleHint": "(एक पंक्ति, जैसे “मौखिक परीक्षा के सभी 300 सवाल, आदर्श जवाबों के साथ”)",
  "sales.category": "श्रेणी",
  "sales.description": "विवरण",
  "sales.descriptionHint": "(उसमें क्या है, आपने कैसे बनाया, कैसे इस्तेमाल करें)",
  "sales.outcomes": "विद्यार्थी क्या सीखेंगे",
  "sales.outcomesHint": "(हर पंक्ति में एक, अधिकतम 8)",
  "sales.tags": "टैग",
  "sales.tagsHint": "(अल्पविराम से अलग, अधिकतम 8)",
  "sales.saveDraft": "ड्राफ़्ट सहेजें",
  "sales.savePage": "पेज सहेजें",
  "sales.publish": "प्रकाशित करें",
  "sales.publishUpdate": "अपडेट प्रकाशित करें",
  "sales.publishHintUpdate": "आपके मौजूदा अध्याय, सवाल और जवाब कोर्स वाले सभी को भेजता है। उनकी अपनी प्रगति सुरक्षित रहती है।",
  "sales.publishHint": "कोर्स को मार्केटप्लेस में दिखाता है। अभी यह मुफ़्त है। आप उसे बदलते रह सकते हैं और बाद में अपडेट प्रकाशित कर सकते हैं।",
  "sales.rights": "सवाल और जवाब मेरे साझा करने के लिए हैं (मैंने उन्हें लिखा है, या जिस सामग्री से वे आए हैं उसके अधिकार मेरे पास हैं)।",
  "sales.publishing": "प्रकाशित हो रहा है…",
  "sales.publishUpdateBtn": "अपडेट प्रकाशित करें",
  "sales.unpublish": "प्रकाशन हटाएँ",
  "sales.noteSaved": "सहेजा गया: मार्केटप्लेस पेज अब इसे दिखाता है।",
  "sales.noteDraft": "ड्राफ़्ट सहेजा गया। प्रकाशित करने तक कोई और इसे नहीं देखता।",
  "sales.notePublishedV": "संस्करण {n} प्रकाशित हुआ: कोर्स वाले सभी को अब आपके नवीनतम सवाल मिलते हैं।",
  "sales.notePublished": "प्रकाशित हो गया! दूसरे उपयोगकर्ता अब इसे मार्केटप्लेस में पा सकते हैं।",
  "sales.noteUnpublished": "प्रकाशन हटाया गया: नए लोग इसे नहीं पा सकते। जिनके पास पहले से है वे इसे रखते हैं।",
  "prog.empty": "अपनी प्रगति देखने के लिए कोर्स बनाएँ और सीखना शुरू करें।",
  "prog.weakConcepts": "कमज़ोर अवधारणाएँ",
  "prog.weakMeta": "भूलें: {lapses} · कठिन चिह्नित: {hard}",
  "prog.byChapter": "अध्याय और विषय के अनुसार",
  "prog.colChapter": "अध्याय / विषय",
  "weak.intro": "आपके हाल के जवाबों में मिली गलतियाँ, अवधारणा के अनुसार। जब उस आइटम के आपके नवीनतम जवाबों में वे नहीं दिखतीं तो गायब हो जाती हैं। अभ्यास आपकी समीक्षा अनुसूची नहीं बदलता।",
  "weak.loading": "आपके हाल के जवाब देखे जा रहे हैं…",
  "weak.empty": "अभी कोई बार-बार होने वाली गलती नहीं है। जवाब देते रहें, वे यहाँ दिखेंगी।",
  "weak.practiceTop.one": "शीर्ष {n} अवधारणा का अभ्यास करें",
  "weak.practiceTop.other": "शीर्ष {n} अवधारणाओं का अभ्यास करें",
  "weak.practiceThis": "इसका अभ्यास करें",
  "weak.seen.one": "{n} बार दिखा, आखिरी {date}",
  "weak.seen.other": "{n} बार दिखा, आखिरी {date}",
  "home.intro": "निर्धारित समीक्षाएँ आपके सीखे हुए को बनाए रखती हैं। बाकी की गिनती समीक्षा सत्र के नियमों से ही होती है।",
  "home.noCourses": "अभी कोई कोर्स नहीं है।",
  "home.createOnDashboard": "अपने डैशबोर्ड पर एक बनाएँ",
  "home.meta": "अभी {due} बाकी · {trained} में से {introduced} आइटम शुरू हुए",
  "activity.pageIntro": "पिछले साल हर दिन पूरे हुए जवाब, आपके समय क्षेत्र में। जवाब को अंतिम ग्रेड मिलते ही गिना जाता है, चाहे वह सही हो या गलत।",
  "reset.title": "अपना पासवर्ड रीसेट करें",
  "reset.intro": "अपने खाते का ईमेल दर्ज करें। हम नया पासवर्ड चुनने का लिंक भेजेंगे; वह 30 मिनट तक, सिर्फ़ एक बार काम करता है।",
  "reset.send": "रीसेट लिंक भेजें",
  "reset.sentMessage": "यदि इस ईमेल का कोई खाता है, तो पासवर्ड रीसेट करने का लिंक भेजा जा रहा है। अपना इनबॉक्स (और स्पैम फ़ोल्डर) देखें।",
  "reset.back": "साइन इन पर वापस जाएँ",
  "reset.chooseTitle": "नया पासवर्ड चुनें",
  "reset.incomplete": "यह लिंक अधूरा है। ईमेल से लिंक फिर से खोलें, या नया माँगें।",
  "reset.done": "आपका पासवर्ड बदल गया है। सभी डिवाइस साइन आउट हो गए: नए पासवर्ड से साइन इन करें।",
  "reset.newPassword": "नया पासवर्ड",
  "reset.repeat": "नया पासवर्ड दोहराएँ",
  "reset.tooShort": "कम से कम {n} अक्षर इस्तेमाल करें।",
  "reset.mismatch": "दोनों पासवर्ड मेल नहीं खाते।",
  "reset.set": "नया पासवर्ड सेट करें",
  "source.aria": "स्रोत अंश",
  "source.closeAria": "स्रोत बंद करें",
  "source.loading": "अंश लोड हो रहा है…",
  "source.open": "स्रोत अंश खोलें",
  "course.loadingCurriculum": "पाठ्यक्रम लोड हो रहा है…",
  "mkt.addPlain": "मेरे कोर्स में जोड़ें",
  "sales.pageName": "मार्केटप्लेस पेज",
};
